// extracted by mini-css-extract-plugin
export var info = "m_h";
export var userDetail = "m_bR";
export var avatar = "m_bx";
export var userInfo = "m_bS";
export var nameWrap = "m_bK";
export var name = "m_bL";
export var badge = "m_bT";
export var starWrap = "m_bV";
export var time = "m_bW";
export var button = "m_bX";
export var like = "m_bY";
export var likeNumber = "m_bZ";
export var specification = "m_b0";
export var tag = "m_b1";
export var content = "m_bv";
export var product = "m_b2";
export var productImg = "m_b3";
export var msg = "m_b4";
export var title = "m_bq";
export var price = "m_b5";
export var arrow = "m_b6";